import { container } from "assets/jss/material-kit-react.jsx";
import imagesStyles from "assets/jss/material-kit-react/imagesStyles";
import commonVariables from "assets/jss/material-kit-react/commonVariables";
import commonStyles from "assets/jss/material-kit-react/commonStyles";

var windowInnerHeight = typeof window !== `undefined` ? window.innerHeight : 0;
var windowInnerWidth = typeof window !== `undefined` ? window.innerWidth : 0;

export const carouselLayout = {
  page: {
    height: windowInnerHeight - 210,
    width: windowInnerWidth
  },
  item: {
    height: 120,
    width: 300
  },
  pageSize: {
    column: 1,
    row: 1
  },
  spacing: {
    vertical: 10,
    horizontal: 10
  }
};

carouselLayout.pageSize = {
  column: Math.floor(carouselLayout.page.width / (carouselLayout.item.width + carouselLayout.spacing.horizontal)),
  row: Math.floor(carouselLayout.page.height / (carouselLayout.item.height + carouselLayout.spacing.vertical))
}


const loginStyle = {
  container,
  ...imagesStyles,
  ...commonStyles,
  background: {
    //transform: "translate3d(0," + windowScrollTop + "px,0)",
    //backgroundImage: "url(" + require('assets/img/backgroundLevel6.jpg') + ")",
    height: `${windowInnerHeight}px`, 
    backgroundColor: '#ddd'
    /* Center and scale the image nicely */
    // backgroundAttachment: "fixed",
    // backgroundPosition: "top",
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "cover"
  },
  prompt: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "Avenir Black",
    fontWeight: "bold",
    fontSize: "1em",
    color: "#0",
    height: '100px',
    //backgroundColor: '#f005'
  },
  carouselPage: {
    display: 'flex !important',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    minHeight: carouselLayout.page.height,
    minWidth: carouselLayout.page.width,
    //backgroundColor: '#0003',
    borderRadius: '10px',
    padding: '10px',
    
  },
  carouselItem: {
    minHeight: carouselLayout.item.height,
    minWidth: carouselLayout.item.width,
    borderRadius: 10,
    borderColor: commonVariables.color.primary,
    borderWidth: 2,
    borderStyle: 'solid',
    backgroundColor: commonVariables.color.background,
  },
  carouselItemContent: {
    display: 'flex !important',
    flexDirection: 'column',
  },
  carouselItemName: {
    textTransform: "none",
    textAlign: "center",
    fontFamily: "Avenir Black",
    fontWeight: "bold",
    fontSize: "1.5em",
    marginTop: "10px",
    color: commonVariables.color.primary
  },
  carouselItemImage: {
    height: carouselLayout.item.height * 0.7,
    width: carouselLayout.item.height * 0.7,
    alignSelf: 'center'
  },

  pinInputContainer: {
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center',
    //backgroundColor: '#f005'
  },

  
  





  

};

export default loginStyle;
